"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hostConfigs = void 0;
exports.hostConfigs = {
    documentManagement: {
        entries: {
            generateParts: false,
            generateComponents: false,
            generateHost: true,
        },
        bundles: [
            {
                conventions: [
                    {
                        part: 'hooks',
                        path: '{,*/}documentManagement/%ComponentName%.hooks.ts',
                    },
                    {
                        part: 'dataSchema',
                        path: '{,*/}documentManagement/%ComponentName%.dataSchema.ts',
                    },
                    {
                        part: 'metaData',
                        path: '{,*/}documentManagement/%ComponentName%.metadata.ts',
                    },
                    {
                        part: 'propertiesSchema',
                        path: '{,*/}documentManagement/%ComponentName%.propsSchema.ts',
                    },
                    {
                        part: 'componentDefinition',
                        path: '{,*/}documentManagement/%ComponentName%.definition.ts',
                    },
                ],
            },
        ],
    },
    dataBinding: {
        entries: {
            generateParts: false,
            generateComponents: true,
            generateHost: true,
        },
        bundles: [
            {
                getComponentName: function (componentName) { return "$w." + componentName; },
                conventions: [
                    {
                        part: 'dataBindingPanel',
                        path: '{,*/}editor/panels/dataBinding/%ComponentName%.dataBindingPanel.ts',
                    },
                ],
            },
        ],
    },
    editor: {
        entries: {
            generateParts: true,
            generateComponents: true,
            generateHost: true,
        },
        bundles: [
            {
                conventions: [
                    {
                        part: 'settingsPanel',
                        path: '{,*/}%ComponentName%/editor/panels/settings/%ComponentName%.settingsPanel.tsx',
                    },
                    {
                        part: 'layoutPanel',
                        path: '{,*/}%ComponentName%/editor/panels/layout/%ComponentName%.layoutPanel.tsx',
                    },
                    {
                        part: 'stylablePanel',
                        path: '{,*/}%ComponentName%/editor/panels/stylable/%ComponentName%.stylablePanel.ts',
                    },
                    {
                        part: 'gfpp',
                        path: '{,*/}%ComponentName%/editor/%ComponentName%.gfpp.ts',
                    },
                    {
                        part: 'metadata',
                        path: '{,*/}%ComponentName%/editor/%ComponentName%.editorMetadata.ts',
                    },
                ],
            },
        ],
    },
    thunderbolt: {
        entries: {
            generateParts: false,
            generateComponents: true,
            generateHost: true,
        },
        bundles: [
            {
                getComponentName: function (componentName, namespace, placeholders) {
                    if (placeholders.SkinName) {
                        return componentName + "_" + placeholders.SkinName;
                    }
                    return componentName;
                },
                conventions: [
                    {
                        part: 'controller',
                        path: '{,*/}%ComponentName%/viewer/%ComponentName%.controller.ts',
                    },
                    {
                        part: 'component',
                        path: '{,*/}%ComponentName%/viewer/{%ComponentName%.tsx,skinComps/*/%SkinName%.skin.tsx}',
                    },
                ],
            },
        ],
    },
};
//# sourceMappingURL=hostConfigs.js.map